import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToast } from 'hooks/ui';
import { reviewRecognition } from 'api/recognitions.service';
import { setDraftRecognition } from 'store/recognition';
import { useApplicationStore } from 'store/application';
import { recognitionKeys } from './queryKeys';

export const useRecognitionReviewQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore();

  const { mutate, isPending } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return reviewRecognition(id);
    },
    onSuccess: (recognition) => {
      toast.success('Recognition has been sent for review successfully');
      setDraftRecognition(recognition);
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: recognitionKeys.all });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
